import KeenSlider from 'keen-slider';

const sliderInstances = new WeakMap();

const updateDots = (root, instance) => {
  if (!root || !instance || !instance.track || !instance.track.details) {
    return;
  }

  const dots = root.querySelectorAll('.strategic-mentorship__dot');
  if (!dots.length) {
    return;
  }

  const current = instance.track.details.rel;

  dots.forEach((dot, index) => {
    dot.classList.toggle('is-active', index === current);
  });
};

const bindDotsNavigation = (root, instance) => {
  if (!root || !instance) {
    return;
  }

  const dots = root.querySelectorAll('[data-strategic-mentorship-dot]');
  if (!dots.length) {
    return;
  }

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = Number(dot.getAttribute('data-slide-index'));
      if (!Number.isNaN(index)) {
        instance.moveToIdx(index);
      }
    });
  });
};

const initStrategicMentorshipSlider = (root) => {
  if (!root || sliderInstances.has(root)) {
    return;
  }

  const sliderElement = root.querySelector('.keen-slider');
  if (!sliderElement) {
    return;
  }

  const totalSlides = sliderElement.querySelectorAll('.keen-slider__slide').length;
  if (totalSlides <= 1) {
    const firstDot = root.querySelector('.strategic-mentorship__dot');
    if (firstDot) {
      firstDot.classList.add('is-active');
    }
    return;
  }

  const slider = new KeenSlider(sliderElement, {
    loop: false,
    mode: 'snap',
    drag: true,
    slides: {
      perView: 1,
      spacing: 0,
    },
    created(instance) {
      updateDots(root, instance);
    },
    slideChanged(instance) {
      updateDots(root, instance);
    },
    updated(instance) {
      updateDots(root, instance);
    },
  });

  bindDotsNavigation(root, slider);
  sliderInstances.set(root, slider);
};

const bootstrapStrategicMentorshipSliders = () => {
  const sliders = document.querySelectorAll('[data-strategic-mentorship-slider]');

  if (!sliders.length) {
    return;
  }

  sliders.forEach((sliderRoot) => {
    initStrategicMentorshipSlider(sliderRoot);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapStrategicMentorshipSliders);
} else {
  bootstrapStrategicMentorshipSliders();
}
